import React from "react";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink,
} from "shards-react";

export default class UserActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }
  handleLogout = () => {
    const cookies = new Cookies();
    cookies.remove("userLoggedIn", { path: "/" });
    window.location = "/";
  };

  toggleUserActions = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };

  render() {
    const cookies = new Cookies();
    const admin = cookies.get("userLoggedIn");
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
          <img
            className="user-avatar rounded-circle mr-2"
            src={require("../../../assits/userIcon.png")}
            alt="User Avatar"
          />{" "}
          <span className="d-none d-md-inline-block">{admin}</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={this.state.visible}>
          <DropdownItem tag={Link} to="user-profile">
            <i className="material-icons">&#xE7FD;</i> Profile
          </DropdownItem>
          <DropdownItem tag={Link} to="edit-user-profile">
            <i className="material-icons">&#xE8B8;</i> Edit Profile
          </DropdownItem>
          <DropdownItem tag={Link} to="requests">
            <i className="material-icons">&#xE2C7;</i> Les demandes
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem
            tag={Link}
            to=""
            className="text-danger"
            onClick={() => this.handleLogout()}
          >
            <i className="material-icons text-danger">&#xE879;</i> Logout
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}
